import { Button } from '@mui/material';
import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

interface IShortcutsHeaderButtons {
    onCreateShortcutGroupClick: () => void;
    onCreateShortcutClick: () => void;
    onOrganizeListClick: () => void;
}

export const ShortcutsHeaderButtons: React.FC<IShortcutsHeaderButtons> = ({
    onCreateShortcutGroupClick,
    onCreateShortcutClick,
    onOrganizeListClick
}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onCreateShortcutGroupMenuClick = () => {
        onCreateShortcutGroupClick();
        handleClose();
    }

    const onCreateShortcutMenuClick = () => {
        onCreateShortcutClick();
        handleClose();
    }

    const onOrganizeListMenuClick = () => {
        onOrganizeListClick();
        handleClose();
    }

    return <div>
        <Button
            variant="outlined"
            color="primary"
            onClick={onOrganizeListMenuClick}
        >
            Organize list
        </Button>
        <Button
            variant="contained"
            color="primary"
            endIcon={<ArrowDropDownIcon />}
            onClick={handleClick}
        >
            Add new
        </Button>
        <Menu
            id="add-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'add-button',
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{
                paper: {
                    style: {
                        transform: 'translateY(6px)',
                    }
                }
            }}
        >
            <MenuItem onClick={onCreateShortcutGroupMenuClick}>Shortcut Group</MenuItem>
            <MenuItem onClick={onCreateShortcutMenuClick}>Shortcut</MenuItem>
        </Menu>
    </div>;
};